module.exports = __webpack_public_path__ + "img/arg.18986af7.svg";